module.exports = __webpack_public_path__ + "img/no_items_added.3c066dbb.svg";